import Vue from 'vue';
import Vuex, { Module } from 'vuex';
import axios from 'axios';

import { handleError } from '@/utils/helperFunctions';

import { endpoints } from '@/endpoints/endpoints';

Vue.use(Vuex);

export const alerts: Module<any, any> = {
  state: {
    alertsList: null,
    open: false,
    fetching: false,
    editAlert: null,
  },
  mutations: {
    toggleAlerts(state: any, data: boolean) {
      state.open = data;
    },
    setAlerts(state: any, data: any) {
      state.alertsList = data;
    },
    setFetching(state: any, data: boolean) {
      state.fetching = data;
    },
    setEditAlert(state: any, data: any) {
      state.editAlert = data;
    },
  },
  actions: {
    async getAlerts(state: any, data: any) {
      this.commit('setFetching', true);
      const res = await axios
        .get(
          endpoints.getAlerts +
          this.state.account.details.userId,
          {
            headers: {
              Authorization: 'bearer ' + this.state.account.token,
            },
          },
        )
        .then((response) => {
          if (response.data.Data.Alerts) {
            this.commit('setAlerts', response.data.Data.Alerts);
            this.commit('setFetching', false);
          } else {
            this.commit('setAlerts', []);
            this.commit('setFetching', false);
          }
          return response.data;
        })
        .catch((err) => {
          const msg = handleError(err, 'Sorry! looks like something went wrong while loading your Alerts');
          this.dispatch('addError', msg);
          this.commit('setAlerts', []);
        });
    },
    toggleAlerts(state, data) {
      this.commit('toggleAlerts', data);
      this.commit('setEditAlert', false);
    },
    async updateAlert(state, data) {
      const res = await axios
        .post(
          endpoints.setAlert,
          data,
          {
            headers: {
              Authorization: 'bearer ' + this.state.account.token,
            },
          },
        )
        .then((response) => {
          this.dispatch('getAlerts');
          this.commit('updateSnackbarMessage', 'Updated Alert');
          this.commit('setEditAlert', null);
          return response.data;
        })
        .catch((err) => {
          const msg = handleError(err, 'Sorry! looks like something went wrong while trying to update your alert');
          this.dispatch('addError', msg);
          return err;
        });
    },
  },
};
